var React = require('react');

function HamburgerOpenInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"line","d":"M48 27.5H0","stroke":"black","strokeMiterlimit":"10","key":0}),React.createElement("path",{"className":"line","d":"M48 19.5H0","stroke":"black","strokeMiterlimit":"10","key":1})]);
}

HamburgerOpenInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = HamburgerOpenInline;

HamburgerOpenInline.default = HamburgerOpenInline;
